export const determineNewPatient = (patients: any) => {
  const analysisDates = patients.map((p: any) => p.analysisDate);
  const mostRecentExam = analysisDates.reduce(
    (latestDate: any, currentDate: any) =>
      currentDate > latestDate ? currentDate : latestDate,
    0,
  );

  return patients.find(
    (p: any) => p.analysisDate === mostRecentExam && !p.displayed,
  );
};

export const sortPatientList = (patient1: any, patient2: any) => {
  // returning a negative value means patient1 will be sorted first.
  // returning a positive value means patient2 will be sorted first
  if (
    patient1.examDate > patient2.examDate ||
    patient1.examDate === undefined
  ) {
    return -1;
  }
  return 1;
};

/**
 * Sometimes firstName could have the full name. Ex: Kiri^Valencia or just the first name
 * firstName can also sometimes be called just name.
 */
export const formatPatientFirstNameAndLastName = (
  firstNameOrName: any,
  lastName: any,
) => {
  if (firstNameOrName && lastName) {
    return `${firstNameOrName.replace('^', ' ')} ${lastName}`;
  }
  if (firstNameOrName) {
    return firstNameOrName.replace('^', ' ');
  }
  if (lastName) {
    return lastName;
  }

  // null indicates this patient does not have an associated name
  return null;
};
